/**
 * Created by Bezsmertnyi Ievgen on 12.09.2020.
 */

const getTranslateFunc = function () {
  let i18n;

  try {
    i18n = require('@/lang/i18n.js').default;
  } catch (error) {
    // console.log(error);
  }

  return i18n
    ? (translateAlias) => i18n.t(translateAlias)
    : (translateAlias) => translateAlias;
};

const getTranslate = getTranslateFunc();

//Должен называться так же как и в modules_components_obj
let module_name = 'Reviews';

let module_settings = {
  module_name,
};

//Пункты в меню
module_settings.menu_items = [
  {
    title: getTranslate('reviews.common.name'),
    module: module_name,
    icon: 'mdi-message-draw',
    show: false,
    route: 'reviews',
  },
];

//Табы модуля
module_settings.tabs_items = {};

module_settings.tabs_items[module_name] = {
  use_tabs: true,
  tabs_items: [
    {
      tab: getTranslate('reviews.common.name'),
      content: '',
      show: false,
      type: 'reviews',
      route: 'reviews',
    },
  ],
};

//Подключенные компоненты
module_settings.components = [
  {
    name: module_name,
    path: 'Component/Reviews.vue',
  },
];

module.exports = { module_settings };
module.exports.default = { module_settings };
